import { useState, useEffect } from 'react';

import ReactDOM from 'react-dom';

import { ReactComponent as CloseIcon } from 'assets/icons/x.svg';

import './Drawer.scoped.scss';

const drawerElement = document.getElementById('drawer');

interface Props {
  children?: React.ReactNode;
  open: boolean;
  side?: 'left' | 'right';
  width?: number | string;
  removeCloseIcon?: boolean;
  onClose?: () => void;
}

const Drawer: React.FC<Props> = ({
  open,
  side = 'right',
  width,
  removeCloseIcon,
  onClose,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(open || false);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleClose = () => {
    if (onClose) onClose();
    setIsOpen(false);
  };

  if (!open || !isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className="drawer-container"
      style={{ justifyContent: side === 'right' ? 'flex-end' : 'flex-start' }}
    >
      <div className="backdrop" onClick={handleClose} />

      <div className={`drawer-content ${side}-animation`} style={{ width }}>
        {!removeCloseIcon && (
          <div className="close-icon">
            <CloseIcon onClick={handleClose} style={{ width: 30, height: 30, color: 'white' }} />
          </div>
        )}

        {children}
      </div>
    </div>,
    drawerElement!
  );
};

export default Drawer;
